import React from "react";
import { CURRICULUM } from "../../mock";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../ui/accordion";

const Curriculum = () => {
  return (
    <section className="py-28 border-t border-[#131c31]" data-testid="curriculum-section">
      <div className="max-w-6xl mx-auto px-6">
        <p className="font-mono text-[10px] tracking-[0.35em] text-[#6f7d9f] uppercase mb-6 reveal">{CURRICULUM.label}</p>
        <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mb-12 reveal">
          <h2 className="font-heading uppercase text-white text-4xl sm:text-5xl tracking-tight" data-testid="curriculum-headline">
            {CURRICULUM.headline}
          </h2>
          <p className="font-mono text-[10px] tracking-[0.25em] text-[#6b9be8] uppercase">{CURRICULUM.sub}</p>
        </div>
        <Accordion type="single" collapsible className="reveal" data-testid="curriculum-accordion">
          {CURRICULUM.modules.map((m) => (
            <AccordionItem key={m.num} value={m.num} className="border-[#1c2740]">
              <AccordionTrigger className="hover:no-underline py-6 group">
                <span className="flex items-center gap-6 text-left">
                  <span className="font-mono text-xs text-[#6b9be8]">{m.num}</span>
                  <span className="font-heading uppercase text-white text-xl sm:text-2xl tracking-tight group-hover:text-[#9db8e8] transition-colors">
                    {m.title}
                  </span>
                </span>
              </AccordionTrigger>
              <AccordionContent className="text-[#8fa0c0] text-sm sm:text-base leading-relaxed pl-12 pb-6">
                {m.body}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default Curriculum;
